var trim = require('./trim');

module.exports = function clean(str) {
  return trim(str).replace(/\s\s+/g, ' ');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/clean.js
// module id = 797
// module chunks = 0